export default __webpack_public_path__ + "static/media/cyball-planet.6da9e0a5.png";